import React, { useState } from 'react';
import { ChevronRight, LogOut } from 'lucide-react';
import { ADMIN_NAV_GROUPS, ADMIN_ROUTE_META, type AdminRoute } from './adminNavigation';
interface AdminSidebarProps {
  activeRoute: AdminRoute;
  onNavigate: (route: AdminRoute) => void;
  onLogout?: () => void;
}
export function AdminSidebar({
  activeRoute,
  onNavigate,
  onLogout
}: AdminSidebarProps) {
  const [collapsed, setCollapsed] = useState(false);
  return <aside className={`flex flex-col bg-white border-r border-gray-200 transition-all duration-200 flex-shrink-0 h-full ${collapsed ? 'w-14' : 'w-56'}`} data-id="element-4415" data-mp="1bdee2kgm5emz">
      
      {/* Header */}
      <div className={`flex items-center border-b border-gray-100 flex-shrink-0 ${collapsed ? 'justify-center px-2 py-4' : 'justify-between px-4 py-4'}`} data-id="element-4416" data-mp="1k7j10ssmm5x8">
        
        {!collapsed && <div className="flex items-center gap-2.5" data-id="element-4417" data-mp="1u56xpo9slni1">
            <div className="w-7 h-7 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-lg flex items-center justify-center shadow-sm" data-id="element-4418" data-mp="1u2b1q5hi98w8">
              <span className="text-white font-black text-sm" data-id="element-4419" data-mp="2dh53li3nq0iy">M</span>
            </div>
            <div data-id="element-4420" data-mp="28i20423bs2d3">
              <div className="text-sm font-bold text-gray-900 leading-tight" data-id="element-4421" data-mp="28hin8zsj845x">
                Admin
              </div>
              <div className="text-[10px] uppercase tracking-wider text-gray-500 font-semibold" data-id="element-4422" data-mp="23jgz40g91enl">
                Beheercentrum
              </div>
            </div>
          </div>}
        <button onClick={() => setCollapsed(c => !c)} className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none" aria-label={collapsed ? 'Uitklappen' : 'Inklappen'} data-id="element-4423" data-mp="2w7mk8ob7t5ny">
          
          <ChevronRight className={`w-4 h-4 transition-transform ${collapsed ? '' : 'rotate-180'}`} data-id="element-4424" data-mp="2igrh7snedisa" />
          
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-3 px-2" data-id="element-4425" data-mp="3a75ov74thyvi">
        {ADMIN_NAV_GROUPS.map((group, index) => <div key={group.label} className="mb-4" data-id="element-4426" data-mp="3a5b53w5a8ct0" data-mpi={index}>
            {!collapsed && <>
                {index > 0 && <div className="h-px bg-gray-100 mx-2 mb-3" data-id="element-4427" data-mp="1d8owgs3itg9p" />}
                <div className="px-2 mb-1.5" data-id="element-4428" data-mp="1d85exchs8tw7">
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-4429" data-mp="yk25ft4j702n">
                    {group.label}
                  </span>
                </div>
              </>}
            <div className="space-y-0.5" data-id="element-4430" data-mp="pj40n8m9qoj0">
              {group.items.map(item => {
            const isActive = activeRoute === item.id;
            const Icon = item.icon;
            return <button key={item.id} onClick={() => onNavigate(item.id)} title={collapsed ? item.label : undefined} className={`w-full flex items-center gap-2.5 rounded-lg transition-colors relative focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${collapsed ? 'justify-center px-2 py-2.5' : 'px-2.5 py-2'} ${isActive ? 'bg-blue-50/50 text-blue-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-4431" data-mp="ug473kn15tan">
                  
                    {isActive && <div className="absolute left-0 top-1.5 bottom-1.5 w-1 bg-blue-600 rounded-r-full" data-id="element-4432" data-mp="3b8cbes1s039" />}
                    <Icon className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-blue-600' : ''}`} data-id="element-4433" data-mp="3uikw81kbermv" />
                  
                    {!collapsed && <span className={`text-sm truncate ${isActive ? 'font-medium' : ''}`} data-id="element-4434" data-mp="89s07kq7bly9">
                    
                        {item.label}
                      </span>}
                  </button>;
          })}
            </div>
          </div>)}
      </nav>

      {/* Footer */}
      <div className={`flex-shrink-0 border-t border-gray-100 ${collapsed ? 'p-2' : 'p-3'}`} data-id="element-4435" data-mp="i1nzv07xrk4l">
        
        {/* Settings footer stays pinned while using the shared route metadata. */}
        {(() => {
        const settingsItem = ADMIN_ROUTE_META.settings;
        const SettingsIcon = settingsItem.icon;
        const isSettingsActive = activeRoute === settingsItem.id;
        return <button onClick={() => onNavigate(settingsItem.id)} title={collapsed ? settingsItem.label : undefined} className={`w-full flex items-center gap-2.5 rounded-lg transition-colors mb-3 relative focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${collapsed ? 'justify-center px-2 py-2.5' : 'px-2.5 py-2'} ${isSettingsActive ? 'bg-blue-50/50 text-blue-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-4436" data-mp="2st7csvmu1zsf">
              
              {isSettingsActive && <div className="absolute left-0 top-1.5 bottom-1.5 w-1 bg-blue-600 rounded-r-full" data-id="element-4437" data-mp="2bjmwd6zcjbs9" />}
              <SettingsIcon className={`w-4 h-4 ${isSettingsActive ? 'text-blue-600' : ''}`} data-id="element-4438" data-mp="2gi6ndlssrdrh" />
              
              {!collapsed && <span className={`text-sm ${isSettingsActive ? 'font-medium' : ''}`} data-id="element-4439" data-mp="2leevif8ku6p5">
                
                  {settingsItem.label}
                </span>}
            </button>;
      })()}

        {onLogout && <button onClick={onLogout} className={`w-full flex items-center justify-center gap-2 rounded-lg text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:outline-none ${collapsed ? 'p-2' : 'px-3 py-2 text-sm font-medium'}`} title={collapsed ? 'Uitloggen' : undefined} data-id="element-4440" data-mp="1spq08wu7cvlb">
          
            <LogOut className="w-4 h-4" data-id="element-4441" data-mp="5tt9oauheuxo" />
            {!collapsed && 'Uitloggen'}
          </button>}

        {/*
         "Terug naar Home" wisselde naar het account van de eerste leerling op
         dit apparaat — een stille identiteitswissel zonder wachtwoord, precies
         zoals bij ouder en leerkracht (zie src/app/PortalSwitch.tsx). Bij een
         beheerder weegt dat het zwaarst: dit is het account dat break glass
         kan openen, en die grens is waardeloos als je er langs kunt door als
         het kind zélf in te loggen.
          Een beheerder die leerdata moet zien, gebruikt break glass. Dat wordt
         gelogd; een accountwissel niet.
         */}
      </div>
    </aside>;
}